
// ProtectedRoute.js
import { useEffect } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { useAuthContext } from './AuthContext';
import { useConfigContext } from './ConfigContext';
import { useRedirect } from './context';

import {    
    sessionService,              
} from '../components/ComponentsLibrary';

const ProtectedRoute = () => {
    const { isAuthenticated, setIsAuthenticated } = useAuthContext();
    const { configLibrary } = useConfigContext();
    //const { config } = useRedirect();
    const navigate = useNavigate();
    const location = useLocation();

    const navigatetoB2C = () => {
        if (configLibrary) {
            if (configLibrary.b2cUrl !== "") {
                window.location.replace(configLibrary.b2cUrl);
                //window.open(configLibrary.b2cUrl, "_self");
            }
        }
    };

    useEffect(() => {

        if (sessionService.getUser()) {
            const loginUserInfo = sessionService.getUser();
            const checkValidToken = loginUserInfo ? loginUserInfo.isTokenValidated : false;
            if (checkValidToken) {
                const checkSiteSelected = loginUserInfo ? loginUserInfo.isSiteSelected : false;
                if (!checkSiteSelected) {
                    navigate('/siteselect', { replace: true });
                }
                else {
                    setIsAuthenticated(true);
                }
            }
            else {
                navigatetoB2C();
            }
        }
        
    }, [isAuthenticated, navigate]);

    return isAuthenticated ? <Outlet /> : null;
};

export default ProtectedRoute;

/* 
useEffect(() => {
    if (isTokenValidated) {
        if (isSiteSelected) {
            setIsAuthenticated(true);
        }
        else {
            setIsAuthenticated(false);
        }
    }
    else {
        setIsAuthenticated(false);
        navigate('/siteselect', { replace: true });
    }

    if (!isAuthenticated) {
        navigate('/siteselect', { replace: true });
    }
}, [isTokenValidated, isSiteSelected, isAuthenticated, navigate]); */